import React, { useEffect, useState } from "react";

// @material-ui/core components
// import { makeStyles } from "@material-ui/core/styles";
// core components
// import Card from "components/Card/Card.js";
// import CardHeader from "components/Card/CardHeader.js";
// import CardBody from "components/Card/CardBody.js";
import PropTypes from "prop-types";

// import Button from "components/CustomButtons/Button.js";
import { Domain } from "Domain";
import axios from "axios";
import LinearIndeterminate from "components/Loader/LinearLoader";
// import CardFooter from "components/Card/CardFooter";
import Danger from "components/Typography/Danger";

export default function Events({ data, Entity, setData, setTotal, loaded }) {
  // const classes = useStyles();
  const [DoctorDetails, setDoctorDetails] = useState([]);
  const [BodyParts, setBodyParts] = useState(null);
  const [Modalities, setModalities] = useState(null);
  const [set, setSet] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [EntityNotFound, setEntityNotFound] = useState(false);
  // console.log("\n \t DoctorDetails:", DoctorDetails);
  // //console.log("\n \t Modalities:", Modalities);
  // //console.log("\n \t BodyParts:", BodyParts);
  //console.log("DoctorDetails", DoctorDetails);
  // if (DoctorDetails != "") {
  //   //console.log("SetDocPan:", setDocPan("Hii"));
  //   // SetDocPan(DoctorDetails.Pan);
  // }
  // if (DoctorsTDSData != undefined) {
  //   if (DoctorDetails != "") {
  //     DoctorsTDSData.map((d) => {
  //       console.log(
  //         "#############################",
  //         d.Name.replace(/ /g, "")
  //           .replace(/[^a-zA-Z0-9 ]/g, "")
  //           .toLowerCase()
  //       );
  //       if (
  //         d.Name.replace(/ /g, "")
  //           .replace(/[^a-zA-Z0-9 ]/g, "")
  //           .toLowerCase() == DoctorDetails.StringId
  //       ) {
  //         d.Pan = DoctorDetails.Pan;
  //       }
  //     });
  //   }
  //   //console.log("$$$$$$$$$$$$$$$$$$$$$$$$", DoctorsTDSData);
  // }
  function HandleGenerate() {
    setLoading(true);
    // console.log("Loading inside HandleGenerate true");
    setSet(true);
  }
  useEffect(() => {
    let formData = new FormData();
    formData.append("Status", "Active");
    axios({
      method: "post",
      url: Domain + "/GetAllModalities.php",
      data: formData,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    })
      .then(function (response) {
        //handle success
        // //console.log("\n \t GetAllModalities:", response);
        if (response.data.success) {
          if (response.data.TotalCount > 0) setModalities(response.data.data);
        }
      })
      .catch(function (response) {
        //handle error
        console.log(response);
      });
  }, []);

  useEffect(() => {
    if (set) {
      // //console.log("Inside Effect");
      const StringId1 = Entity.replace(/ /g, "")
        .replace(/[^a-zA-Z0-9 ]/g, "")
        .toLowerCase();
      //console.log("String ID:::::::::::::::::::::::::", StringId1);
      ///////////////////////////////////////
      //Get Doctor Data correcsponding to the stringid
      let formData = new FormData();
      formData.append("StringId", StringId1);
      axios({
        method: "post",
        url: Domain + "/GetDoctorByName.php",
        data: formData,
        config: { headers: { "Content-Type": "multipart/form-data" } },
      })
        .then(function (response) {
          //handle success
          // //console.log("\n \t getDoctorByName:", response);
          if (response.data.success) {
            setEntityNotFound(false);
            setDoctorDetails(response.data.data[0]);
            // setDocPan(response.data.data[0].Pan);
            //if Doctor details got from db, then get the body parts from db
            let formData = new FormData();
            formData.append("Id", response.data.data[0].Id);
            axios({
              method: "post",
              url: Domain + "/GetBodypartsByDoctorId.php",
              data: formData,
              config: { headers: { "Content-Type": "multipart/form-data" } },
            })
              .then(function (response) {
                //handle success
                // //console.log("\n \t GetBodypartsByDoctorId:", response);
                if (response.data.success) {
                  if (response.data.TotalCount > 0) {
                    setBodyParts(response.data.data);
                  }
                }
              })
              .catch(function (response) {
                //handle error
                console.log(response);
              });
          } else {
            setEntityNotFound(true);
            // Doctor not in DB — fetch global price list as fallback
            const fetchPrices = (type) => {
              const fd = new FormData();
              fd.append("Status", "Active");
              fd.append("Type", type);
              return axios({
                method: "post",
                url: Domain + "/GetAllPriceData.php",
                data: fd,
                config: { headers: { "Content-Type": "multipart/form-data" } },
              })
                .then((r) => (r.data && r.data.data ? r.data.data : []))
                .catch(() => []);
            };
            Promise.all([fetchPrices("CT"), fetchPrices("MR")]).then(
              ([ct, mr]) => {
                const combined = [...ct, ...mr].map((item) => ({
                  BodyPart: item.Proceedure,
                  Price: item.Price,
                  StringId: (item.Proceedure || "")
                    .replace(/ /g, "")
                    .replace(/[^a-zA-Z0-9]/g, "")
                    .toLowerCase(),
                }));
                setBodyParts(combined.length > 0 ? combined : []);
              }
            );
          }
        })
        .catch(function (response) {
          console.log(response);
          setEntityNotFound(true);
          // Doctor not in DB — fetch global price list as fallback
          const fetchPrices = (type) => {
            const fd = new FormData();
            fd.append("Status", "Active");
            fd.append("Type", type);
            return axios({
              method: "post",
              url: Domain + "/GetAllPriceData.php",
              data: fd,
              config: { headers: { "Content-Type": "multipart/form-data" } },
            })
              .then((r) => (r.data && r.data.data ? r.data.data : []))
              .catch(() => []);
          };
          Promise.all([fetchPrices("CT"), fetchPrices("MR")]).then(
            ([ct, mr]) => {
              const combined = [...ct, ...mr].map((item) => ({
                BodyPart: item.Proceedure,
                Price: item.Price,
                StringId: (item.Proceedure || "")
                  .replace(/ /g, "")
                  .replace(/[^a-zA-Z0-9]/g, "")
                  .toLowerCase(),
              }));
              setBodyParts(combined.length > 0 ? combined : []);
            }
          );
        });
    }
  }, [set]);

  const bodyPartAliasMap = {
    cxr: "dxchest",
    chestxray: "dxchest",
    chest: "dxchest",
    hrct: "hrctchest",
    brain: "mribrain",
    ctbrain: "nccthead",
    cthead: "nccthead",
    braincontrast: "cemribrain",
    ctbraiin: "nccthead",
    brainwspine: "mribrain",
    ls: "mrilsspine",
    lspine: "mrilsspine",
    lsspine: "mrilsspine",
    dxlspine: "dxlsspine",
    xraylsspine: "dxlsspine",
    cs: "mricspine",
    cerspine: "dxcspine",
    xraycspine: "dxcspine",
    mricervicalspine: "mricspine",
    ts: "mridspine",
    tspine: "mridspine",
    mrits: "mridspine",
    mritspine: "mridspine",
    dlspine: "mridlspine",
    d_lspine: "mridlspine",
    rtknee: "dxrtknee",
    ltknee: "dxltknee",
    bothknee: "dxbothknee",
    bothknees: "dxbothknee",
    knee: "dxrtknee",
    dxknee: "dxrtknee",
    rthip: "dxrthip",
    lthip: "dxlthip",
    dxhip: "dxhipjoints",
    hip: "dxhipjoints",
    hipjoints: "dxhipjoints",
    bothhips: "dxhipjoints",
    rtfoot: "dxrtfoot",
    ltfoot: "dxltfoot",
    xrayltfoot: "dxltfoot",
    dxfoot: "dxrtfoot",
    rtankle: "dxrtankle",
    ltankle: "dxltankle",
    ankle: "dxrtankle",
    dxankle: "dxrtankle",
    bothankles: "dxbothankle",
    rtwrist: "dxrtwrist",
    ltwrist: "dxltwrist",
    wrist: "dxrtwrist",
    bothwrist: "dxrtwrist",
    rtshoulder: "dxrtshoulder",
    ltshoulder: "dxltshoulder",
    dxshoulder: "dxrtshoulder",
    rtelbow: "dxrtelbow",
    ltelbow: "dxltelbow",
    dxelbow: "dxrtelbow",
    lthand: "dxlthand",
    rthand: "dxrthand",
    dxhand: "dxrthand",
    hand: "dxrthand",
    bothhands: "dxbothhand",
    dxcehst: "dxchest",
    cehst: "dxchest",
    dxhumerus: "dxrthumerus",
    humerus: "dxrthumerus",
    humerusxray: "dxrthumerus",
    dxleg: "dxrtleg",
    rtleg: "dxrtleg",
    rtleghip: "dxrtleg",
    dxforearm: "dxrtforearm",
    forearm: "dxrtforearm",
    dxfemur: "dxrtfemur",
    pelvis: "dxpelvis",
    abdomen: "dxabdomen",
    skull: "dxskull",
    kub: "dxkub",
    hsg: "dxhsg",
    ivp: "dxivp",
    mammogram: "dxmammogram",
    dxsinus: "ncctpns",
    ctpa: "ctapulmonary",
    ctchest: "ncctchest",
    ctpns: "ncctpns",
    ctpelvis: "ncctpelvis",
    ctkub: "ncctkub",
    ctivu: "ncctkub",
    ctabdomenpelvis: "ncctwabdomen",
    ctlthip: "ncctlthip",
  };
  const toAmount = (value) => {
    const amount = Number.parseFloat(
      String(value ?? "").replace(/[^0-9.-]/g, "")
    );
    return Number.isFinite(amount) ? amount : 0;
  };
  const normalizeEntityKey = (value) =>
    String(value || "")
      .replace(/[^a-zA-Z0-9]/g, "")
      .toLowerCase();
  const getMinutesFromTime = (value) => {
    const match = String(value || "").match(
      /(\d{1,2}):(\d{2})(?::\d{2})?\s*(am|pm)?/i
    );
    if (!match) return null;
    let hour = Number(match[1]);
    const meridiem = match[3]?.toLowerCase();
    if (meridiem === "pm" && hour < 12) hour += 12;
    if (meridiem === "am" && hour === 12) hour = 0;
    if (hour > 23) return null;
    return hour * 60 + Number(match[2]);
  };
  const isTimeInWindow = (dateTime, startTime, endTime) => {
    const current = getMinutesFromTime(dateTime);
    const start = getMinutesFromTime(startTime);
    const end = getMinutesFromTime(endTime);
    if (current === null || start === null || end === null) return false;
    if (start === end) return true;
    if (start < end) return current >= start && current < end;
    return current >= start || current < end;
  };

  const normalizeBodyPartId = (raw) => {
    const sid = getRawBodyPartId(raw);
    return bodyPartAliasMap[sid] || sid;
  };

  const getRawBodyPartId = (raw) =>
    String(raw || "")
      .replace(/ /g, "")
      .replace(/[^a-zA-Z0-9]/g, "")
      .toLowerCase();

  const getUniqueIds = (ids) =>
    ids.filter((id, index) => id && ids.indexOf(id) === index);

  const getBodyPartCandidates = (rawBodyPart, modalityName) => {
    const rawId = getRawBodyPartId(rawBodyPart);
    const aliasId = normalizeBodyPartId(rawBodyPart);
    const strippedId = rawId.replace(/^(cemri|mri|ncct|cect|dx|ct)/, "");
    const modality = String(modalityName || "").toUpperCase();
    const candidates = [rawId, aliasId];

    if (modality === "MR") {
      candidates.push(`mri${strippedId}`, `cemri${strippedId}`);
      if (["ts", "tspine"].includes(strippedId)) candidates.push("mridspine");
      if (strippedId.includes("cspine")) candidates.push("mricspine");
      if (strippedId.includes("lspine") || strippedId.includes("lumbarspine")) {
        candidates.push("mrilsspine");
      }
      if (strippedId.includes("prostate")) candidates.push("mriprostate");
    }

    if (modality === "DX") {
      candidates.push(`dx${strippedId}`);
      if (["ts", "tspine"].includes(strippedId)) candidates.push("dxdspine");
      if (strippedId.includes("cspine")) candidates.push("dxcspine");
      if (strippedId.includes("cehst") || strippedId.includes("chest")) {
        candidates.push("dxchest");
      }
    }

    if (modality === "CT") {
      candidates.push(`ncct${strippedId}`, `cect${strippedId}`);
      if (strippedId.includes("cspine")) {
        candidates.push("ncctcspine", "cectcspine");
      }
      if (strippedId.includes("chest")) {
        candidates.push("ncctchest", "hrctchest");
      }
    }

    return getUniqueIds(candidates);
  };

  const getMatchedBodyPartPrice = (candidateIds) => {
    const bodyParts = Array.isArray(BodyParts) ? BodyParts : [];
    const matchedBodyPart = bodyParts.find((bodyPart) =>
      [
        bodyPart.StringId,
        bodyPart.BodyPart,
        bodyPart.Proceedure,
      ].some((value) => candidateIds.includes(normalizeBodyPartId(value)))
    );
    return matchedBodyPart ? toAmount(matchedBodyPart.Price) : null;
  };

  const getCompositeBodyPartPrice = (rawBodyPart, modalityName) => {
    const rawId = getRawBodyPartId(rawBodyPart);
    const modality = String(modalityName || "").toUpperCase();

    if (modality === "DX" && rawId.includes("bothhands")) {
      const rightHand = getMatchedBodyPartPrice(["dxrthand"]);
      const leftHand = getMatchedBodyPartPrice(["dxlthand"]);
      return rightHand !== null && leftHand !== null
        ? rightHand + leftHand
        : null;
    }

    if (
      modality === "MR" &&
      rawId.includes("prostate") &&
      (rawId.includes("lumbar") || rawId.includes("lspine"))
    ) {
      const prostate = getMatchedBodyPartPrice(["mriprostate"]);
      const lsSpine = getMatchedBodyPartPrice(["mrilsspine"]);
      return prostate !== null && lsSpine !== null ? prostate + lsSpine : null;
    }

    return null;
  };
  const getBodyPartPrice = (rawBodyPart, modalityName) => {
    const rawId = getRawBodyPartId(rawBodyPart);
    if (rawId.includes("complimentary") || rawId.includes("complimentry")) {
      return 0;
    }

    const compositePrice = getCompositeBodyPartPrice(rawBodyPart, modalityName);
    if (compositePrice !== null) return compositePrice;

    return getMatchedBodyPartPrice(
      getBodyPartCandidates(rawBodyPart, modalityName)
    );
  };
  const getNightCharge = (row) => {
    const rowClientName = normalizeEntityKey(row.Client);
    const modalityRows = (Array.isArray(Modalities) ? Modalities : []).filter(
      (modality) =>
        normalizeEntityKey(modality.ModalityName) ===
        normalizeEntityKey(row.Modality)
    );
    const matchedModality = modalityRows.find(
      (modality) =>
        String(modality.DoctorId || "") === String(DoctorDetails.Id || "") &&
        normalizeEntityKey(modality.ClientName) === rowClientName
    );
    const defaultModality =
      modalityRows.find((modality) => !modality.DoctorId) || modalityRows[0];

    if (!matchedModality && !defaultModality) return 0;

    const nightCharge =
      matchedModality?.DoctorNightCharge ||
      defaultModality?.DefaultDoctorNightCharge;
    const nightStart =
      matchedModality?.DoctorNightStartTime ||
      defaultModality?.DefaultDoctorNightStartTime;
    const nightEnd =
      matchedModality?.DoctorNightEndTime ||
      defaultModality?.DefaultDoctorNightEndTime;
    const hasTimeWindow = nightStart && nightEnd;
    const isNight = hasTimeWindow
      ? isTimeInWindow(row.ReportedTime, nightStart, nightEnd)
      : row.DayNight == "Night";

    row.DayNight = isNight ? "Night" : "Day";
    return isNight ? toAmount(nightCharge) : 0;
  };

  useEffect(() => {
    //console.log("generate");
    // //console.log("body___part:", BodyParts, "Modality__ss:", Modalities);
    if (BodyParts != null && Modalities != null) {
      //console.log("generate1");
      var Total = 0;

      if (data) {
        data.map((d) => {
          let generatedPrice = null;
          const bodyPartText = String(d.BodyPart || "");
          if (bodyPartText.indexOf(",") > -1) {
            generatedPrice = 0;
            let matchedAnyPart = false;
            const splitData = bodyPartText.split(",");
            // //console.log("Split Data::::", splitData);
            splitData.map((s) => {
              const partPrice = getBodyPartPrice(s, d.Modality);
              if (partPrice !== null) {
                generatedPrice += partPrice;
                matchedAnyPart = true;
              }
            });
            if (!matchedAnyPart) generatedPrice = null;
          } else {
            generatedPrice = getBodyPartPrice(bodyPartText, d.Modality);
          }

          if (generatedPrice !== null) {
            generatedPrice += getNightCharge(d);
          }
          d.Price = generatedPrice === null ? "Not Generated" : generatedPrice;
          Total = Total + (generatedPrice || 0);
        });

        setData(data);
        setLoading(false);
        setTotal(Total);
        //console.log("Data After Price updation:::::", data);
      }
    }
  }, [BodyParts, Modalities, DoctorDetails]);
  useEffect(() => {
    if (loaded) {
      HandleGenerate();
    }
  }, [loaded]);

  return (
    <>
      {EntityNotFound ? <Danger>Doctor {Entity} Not found</Danger> : <></>}
      {Loading ? (
        <>
          <LinearIndeterminate />
        </>
      ) : (
        <></>
      )}
    </>
  );
}
Events.propTypes = {
  Entity: PropTypes.any,
  data: PropTypes.any,
  setData: PropTypes.any,
};
